import { createPortal } from 'react-dom';

export const Portal = ({ children }) => {
  const target = document.body;

  return createPortal(children, target);
};
